import React from 'react'
const server = process.env.REACT_APP_SERVER;

function PrincipalTarjetaMiguel() {
    return (
        <div className='container-fluid vh-100 fondoImagenTarjeta'>
            <div className='container-fluid w-100 text-center py-2'>
                <img src={`${server}/imagenes/logoKingdom.png`} className='img-fluid mx-auto' width={200}></img>
            </div>
            <div className='container-fluid py-4'>
                <div className='text-center text-light textMonserratBold'>
                    MBA. Miguel Angel Oporto Terrazas
                </div>
                <div className='text-center reaccionOn fw-bold textMonserratBold'>
                    GERENTE OPERATIVO
                </div>
            </div>
            <div className='container-fluid mb-4'>
                <div className='row row-cols-2 gx-1 mb-4'>
                    <div className='col-2 text-center'>
                        <a href="tel:+59178002275"><img src={`${server}/imagenes/watsapp.png`} className='img-fluid mx-auto' width={40}></img></a>
                    </div>
                    <div className='col-10 text-start text-light my-auto textMonserrat'>
                        <div>(+591) 780 02275</div>
                    </div>  
                </div>
                <div className='row row-cols-2 gx-1 mb-4'>
                    <div className='col-2 text-center'>
                        <a href="tel:+5914434319"><img src={`${server}/imagenes/telefono.png`} className='img-fluid mx-auto' width={40}></img></a>
                    </div>
                    <div className='col-10 text-start text-light my-auto textMonserrat'>
                        <div>(+591) 4 434319</div>
                    </div>  
                </div>
                <div className='row row-cols-2 gx-1 mb-4'>
                    <div className='col-2 text-center'>
                        <a href='mailto:gerente.operativo@chickenskingdom.com'><img src={`${server}/imagenes/correo.png`} className='img-fluid mx-auto' width={40}></img></a>
                    </div>
                    <div className='col-10 text-start text-light my-auto textMonserrat' style={{fontSize:'12px'}}>
                        <div>gerente.operativo@chickenskingdom.com</div>
                    </div>  
                </div>
                <div className='row row-cols-2 gx-1 mb-4'>
                    <div className='col-2 text-center'>
                        <a href='https://maps.app.goo.gl/iaQHTzJbU1KzPwcP7'><img src={`${server}/imagenes/ubicacion.png`} className='img-fluid mx-auto' width={40}></img></a>
                    </div>
                    <div className='col-10 text-start text-light my-auto textMonserrat'>
                        <div>Av. Gualberto Villarroel #1170</div>
                        <div>entre Aniceto Padilla y Oblitas</div>
                    </div>  
                </div>
            </div>
            <div className='container-fluid text-center'>
                <a className='text-light textMonserrat' href='http://www.chickenskingdom.com.bo' target='_blank'>www.chickenskingdom.com.bo</a>
            </div>
        </div>
    )
}

export default PrincipalTarjetaMiguel